import React from 'react'
import {Provider} from 'react-redux'
import {Route} from 'react-router'
import {BrowserRouter} from 'react-router-dom'
import {createStore, combineReducers, applyMiddleware} from 'redux'
import logger from 'redux-logger'
import OAuthApplication from './pages/OAuthApplication'
import {reducer as formReducer} from 'redux-form'
import {init} from './actions/oauthApplication'
import appReducer from './reducers/oauthApplication'
import notificationReducer from './reducers/notification'
import AppContainer from './frags/AppContainer'
const NEW_APPLICATION_PATH = '/oauth/applications/new'
const EDIT_APPLICATION_PATH = '/oauth/applications/:id/edit'

const middlewares = []

if (process.env.RAILS_ENV === 'development') {
  middlewares.unshift(logger)
}

const store = createStore(combineReducers({
  form: formReducer,
  app: appReducer,
  notification: notificationReducer
}), applyMiddleware(...middlewares))

class StdRoute extends Route {
  componentWillMount () {
    if (this.state.match) {
      if (this.props.path === EDIT_APPLICATION_PATH) {
        const {app, scopes, categories} = this.props
        store.dispatch(init({app, scopes, categories}))
      } else if (this.props.path === NEW_APPLICATION_PATH) {
        const {app, scopes, categories} = this.props
        store.dispatch(init({app, scopes, categories}))
      }
    }
  }

  render () {
    if (this.state.match) {
      return super.render()
    } else {
      return null
    }
  }
}

class App extends React.Component {
  render () {
    return <Provider store={store}>
      <BrowserRouter forceRefresh>
        <AppContainer>
          <StdRoute exact path={EDIT_APPLICATION_PATH} component={OAuthApplication} {...this.props} />
          <StdRoute exact path={NEW_APPLICATION_PATH} component={OAuthApplication} {...this.props} />
        </AppContainer>
      </BrowserRouter>
    </Provider>
  }
}

export default App



// WEBPACK FOOTER //
// app/javascript/components/App.js